import React from 'react';
import ReactDOM from 'react-dom';
import '~/assets/styles/common.scss';
import PrivacyPolicyNew from '../../components/pages/privacypolicyNew2';

ReactDOM.render(
  <PrivacyPolicyNew />,
  document.getElementById('mst-app'),
);



// WEBPACK FOOTER //
// ./src/entries/privacypolicyNew2/privacypolicyNew.jsx